import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import ErrorBoundary from './components/ErrorBoundary'
import { ToastProvider } from './components/Toast'
import Navigation from './components/Navigation'
import ProtectedRoute from './components/ProtectedRoute'
import Login from './components/Login'
import QueueView from './views/QueueView'
import KanbanView from './views/KanbanView'
import GraphView from './views/GraphView'
import NotFound from './views/NotFound'
import { isAuthenticated } from './services/auth'

function AppLayout({ children }: { children: React.ReactNode }) {
  const location = useLocation()
  const showNav = isAuthenticated() && location.pathname !== '/login'

  return (
    <div className="flex flex-col min-h-screen">
      {showNav && <Navigation />}
      <main className="flex-1 relative z-10">
        {children}
      </main>
    </div>
  )
}

function App() {
  return (
    <ErrorBoundary>
      <ToastProvider>
        <BrowserRouter>
          {/* Celestial Background Mesh */}
          <div className="celestial-bg" aria-hidden="true" />
          <div className="min-h-screen relative">
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route
                path="/"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <Navigate to="/queue" replace />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/queue"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <QueueView />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/kanban"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <KanbanView />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route
                path="/graph"
                element={
                  <ProtectedRoute>
                    <AppLayout>
                      <GraphView />
                    </AppLayout>
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </div>
        </BrowserRouter>
      </ToastProvider>
    </ErrorBoundary>
  )
}

export default App
